import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import { LoginData } from "../../types";
import { BarLoader, ClipLoader } from "react-spinners";

interface LoginProps {
  formData: LoginData;
  onchange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  loginUser: (e: React.FormEvent<HTMLFormElement>) => void;
  loading: boolean;
}

const Logins: React.FC<LoginProps> = ({
  formData,
  onchange,
  loginUser,
  loading,
}) => {
  const togglePassword = () => {
    const password = document.getElementById("password") as HTMLInputElement;
    const eyes = document.getElementById("togglePassword");

    if (password.type === "password") {
      password.type = "text";
      if (eyes) {
        eyes.className = "bi bi-eye";
      }
    } else {
      password.type = "password";
      if (eyes) {
        eyes.className = "bi bi-eye-slash";
      }
    }
  };

  return (
    <Container>
      <Row>
        <Col sm={12} md={12}>
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ marginTop: "10%" }}
          >
            <div className="card w-50 shadow-lg p-3 mb-5 bg-body-tertiary rounded border-0">
              <div className="card-body py-5">
                <div className="d-flex justify-content-center mb-3">
                  <Image
                    src="/images/logo.png"
                    className="img-fluid"
                    alt="images"
                  />
                </div>
                <h3 className="text-center fw-bold">Sign In </h3>

                <div className="form-group mb-4">
                  <label className="form-label">Email Address</label>
                  <input
                    type="email"
                    className="form-control p-3 rounded-0"
                    name="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={onchange}
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Password</label>
                  <div className="input-group">
                    <input
                      type="password"
                      className="form-control p-3 rounded-0"
                      placeholder="password"
                      name="password"
                      id="password"
                      value={formData.password}
                      onChange={onchange}
                    />
                    <span className="input-group-text">
                      <i
                        className="bi bi-eye-slash"
                        id="togglePassword"
                        onClick={togglePassword}
                      ></i>
                    </span>
                  </div>
                </div>
                <div className="mb-5">
                  <Link
                    to="/forgot-password"
                    className="float-end text-decoration-none"
                  >
                    Forgot Password ?
                  </Link>
                </div>

                <div className="form-group mt-3">
                  {loading && loading ? (
                    <BarLoader
                      color="#073367"
                      loading={loading}
                      width={150}
                      aria-label="Loading Spinner"
                      data-testid="loader"
                    />
                  ) : (
                    <button
                      className="btn btn-primary w-100 p-3"
                      onClick={(e) =>
                        loginUser(
                          e as unknown as React.FormEvent<HTMLFormElement>
                        )
                      }
                    >
                      <h4>Login</h4>
                    </button>
                  )}
                </div>
                <div className="text-primary pt-3">
                  <NavLink to={"/signup"} className="text-decoration-none">
                    Register Here{" "}
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Logins;
